import config from "@/config/config.js"
import ws from "./webSocket"

export default {
    linkPath: config.BASE_URL,
    miniPath: config.SOURCE_URL + "/public/mini",
    uploadPath: config.BASE_URL + "/api/Upload/upload-img",
    wsPath: 'www.chemical-link.com/wss',
    H5link: 'https://wap.chemical-link.com/#/'
}
